export default __webpack_public_path__ + "static/media/urgency-menu.8c4e822a.png";